import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';

import Button from '../../../../components/global/Button';
import ContributeButton from '../../../../components/global/ContributeButton';
import ArrowRight from '../../../../components/icons/ArrowRight';
import { getAsset } from '../../../../util/assets';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};

const WebGalleryAlbumNullState = ({ album }) => {
  const startDate = album?.start_date ? new Date(album.start_date) : null;
  const endDate = album?.end_date ? new Date(album.end_date) : null;
  const startAndEndDateSameDay =
    !startDate || !endDate ? true : isSameDay(startDate, endDate);
  const dateFormat = 'MMMM do, yyyy';

  return (
    <div className="text-center mb-3 mt-2 web-gallery-header-container">
      <div className="web-gallery-null-state-title-wrapper">
        <p className="web-gallery-null-state-welcome">Welcome to</p>
        <h2 className="web-gallery-null-state-title"> {album.name} </h2>
        {startDate && (
          <p className="text-black text-dark text-sm">
            {format(startDate, dateFormat)}{' '}
            {endDate &&
              !startAndEndDateSameDay &&
              `- ${format(endDate, dateFormat)}`}
          </p>
        )}
      </div>

      <div className="web-gallery-null-state-copy">
        <img
          src={getAsset('/waldo-icon.svg')}
          className="grayscale-faded mb-1"
          width="40"
          alt="Waldo Icon"
        />
        <p className="text-extra-bold text-light">
          No photos have been uploaded yet.
        </p>
      </div>
      <div className="web-gallery-null-state-btn-container">
        <ContributeButton>
          {({ onClick }) => (
            <Button
              btnStyle="reset"
              className="web-gallery-null-state-btn"
              onClick={onClick}
            >
              <img
                src={getAsset('/album-cards-uploads.svg')}
                alt="Find my photos"
              />

              <div className="web-gallery-null-state-btn-action">
                <span>Upload Photos</span>
                <ArrowRight />
              </div>
            </Button>
          )}
        </ContributeButton>
      </div>
    </div>
  );
};

WebGalleryAlbumNullState.propTypes = propTypes;

export { WebGalleryAlbumNullState as WebGalleryAlbumNullStateComponent };

export default WebGalleryAlbumNullState;
